import React, { useState } from 'react';
import { ProgressBar } from 'react-bootstrap';

const CustomProgressBar = ({ progress, label }) => {
  const [customStyle, setCustomStyle] = useState({
    height: '50px',
    backgroundColor: '#6c757d', // Cor padrão
  });

  // Atualizar o estilo ao montar o componente
  //updateStyle();

  return (
    <ProgressBar
      now={progress}
      label={label}
      variant="custom"
      style={customStyle}
    />
  );
};

export default CustomProgressBar;